import { announceCartFeedback, getCartErrorMessage } from '@theme/cart-feedback';

/**
 * <s-quick-add data-variant-id="123">: quick add button for product cards that live inside
 * other forms (e.g. the collection filter form), where a nested product form is not allowed.
 * Adds one unit through Standard Actions, then opens the cart drawer, like <s-product-form>.
 */
class QuickAdd extends HTMLElement {
  #busy = false;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = async (event) => {
    const button = event.target.closest('button');
    if (!button || this.#busy) return;
    event.preventDefault();
    const variantId = this.dataset.variantId;
    if (!variantId) return;

    this.#busy = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('opacity-50', 'cursor-wait');
    try {
      const result = await window.Shopify.actions.updateCart(
        { lines: [{ merchandiseId: variantId, quantity: 1 }] },
        { event: { context: 'product' } }
      );
      const message = result?.userErrors?.[0]?.message;
      if (message) {
        await announceCartFeedback(message, { toast: true });
      } else {
        await window.Shopify.actions.openCart?.();
      }
    } catch (error) {
      await announceCartFeedback(getCartErrorMessage(error), { toast: true });
    } finally {
      this.#busy = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('opacity-50', 'cursor-wait');
    }
  };
}

if (!customElements.get('s-quick-add')) customElements.define('s-quick-add', QuickAdd);
